import { Inject, Injectable } from '@angular/core';
import { LoadersService } from '../utils/loaders/loaders.service';
import { LoaderActions } from '../utils/loaders/loader-actions.enum';
import { LoaderManagement } from '../utils/loaders/loader-management';
import { ModalLoaderData } from '../utils/loaders/modal-loader.service';
import { MonthForm } from '../utils/pipes/monthForm';
import { CommonModalService } from '../utils/modals/common-modal.service';
import { IContractDetails } from '../interfaces/contract-details.interface';
import { IInternetDetails } from '../interfaces/internet-details.interface';
import { CommonModalTemplatesEnum } from '../utils/modals/common-modal-templates.enum';

@Injectable()
export class DetailsModalService {
  readonly modalsConfig = {
    contract: {
      templateName: CommonModalTemplatesEnum.CONTRACT_DETAILS_MODAL,
      endpointUrl: 'newCart.contractDetails',
    },
    internet: {
      templateName: CommonModalTemplatesEnum.INTERNET_DETAILS_MODAL,
      endpointUrl: 'newCart.internetDetails',
    }
  };

  private modalType: string;
  private sourceElement: HTMLElement;
  private monthFormat = new MonthForm();


  constructor(
    @Inject('Endpoint') private endpoint: any,
    private commonModalService: CommonModalService,
    private loadersService: LoadersService,
  ) {
  }

  public showContractDetails(_sourceElement?: HTMLElement): void {
    this.prepareModal('contract', _sourceElement);
  }

  public showInternetDetails(_sourceElement?: HTMLElement): void {
    this.prepareModal('internet', _sourceElement);
  }

  private setType(_type: string): void {
    this.modalType = _type;
  }

  private setElement(_sourceElement: HTMLElement = undefined): void {
    this.sourceElement = _sourceElement;
  }

  private prepareModal(_type: string, _sourceElement?: HTMLElement): void {
    this.setElement(_sourceElement);

    this.setType(_type);

    this.startLoader();

    this.sendRequest();
  }

  private sendRequest(): void {
    const endpointUrl = this.modalsConfig[this.modalType].endpointUrl;

    this.endpoint(endpointUrl)
      .run()
      .then((response: IInternetDetails) => {
        this.stopLoader().runAfterDelay(() => {
          if (response) {
            this.showModal(response);
          }
        });
      })
      .catch(() => {
        this.stopLoader();
      });
  }

  private showModal(response: any): void {
    let modalData = response;

    modalData.templateName = this.modalsConfig[this.modalType].templateName;

    modalData.termOfServiceNumber = (!modalData.termOfServiceNumber || modalData.termOfServiceNumber === -1) ? 'czas nieokreślony' : modalData.termOfServiceNumber + ' ' +
      this.monthFormat.transform(modalData.termOfServiceNumber);

    modalData.offertType = this.modalType;

    modalData.themeResourcePath = (window['themeResourcePath']) ? window['themeResourcePath'] : '';

    modalData.sourceElement = this.sourceElement;

    this.commonModalService.setData(modalData);

  }

  private startLoader(): void {
    const DRAWING_CONTRACT_DETAILS: string = 'Ładuję szczegóły oferty';

    this.loadersService.start(
      LoaderActions.MODAL_LOADER,
      new ModalLoaderData(
        DRAWING_CONTRACT_DETAILS,
        true
      ),
      true
    );
  }

  private stopLoader(): LoaderManagement {
    return this.loadersService.stop(LoaderActions.MODAL_LOADER);
  }
}
